import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import useStyles from './styles';

import MenuItem from '@material-ui/core/MenuItem';

const userTypes = [
  {
    value: 'user',
    label: 'Usuário',
  },
  {
    value: 'admin',
    label: 'Administrador',
  }
]

const NewUser = ({title, user, submitForm, update}) => {

  const classes = useStyles();

  const [state, setState] = useState({...user});

  const onStateChange = id => event => {
    event.persist && event.persist();
    setState({...state, [id]: event.target.value});
  };

  useEffect(() => setState(user), [user]);

  const handleSubmit = event => {
    event.preventDefault();
    submitForm(state);
    setState(user);
  };

  return (
    <form onSubmit={handleSubmit} className={classes.container}>
      <Grid container spacing={8}>
        <Grid item xs={12}>
          {title}
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            id='name'
            label='Nome'
            placeholder='Nome'
            autoComplete='off'
            className={classes.input}
            value={state.name}
            onChange={onStateChange('name')}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='email'
            label='Email'
            placeholder='Email'
            autoComplete='off'
            type='email'
            className={classes.input}
            value={state.email}
            onChange={onStateChange('email')}
            fullWidth
            required
            disabled={update}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='userType'
            select
            fullWidth
            required
            label='Tipo'
            value={state.userType}
            onChange={onStateChange('userType')}
            className={classes.input}
            helperText=''
          >
            {userTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            size='large'
            fullWidth
            className={classes.margin}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
};

NewUser.propTypes = {
  title: PropTypes.object.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    userType: PropTypes.bool
  }),
  submitForm: PropTypes.func.isRequired,
  update: PropTypes.bool.isRequired
};

NewUser.defaultProps = {
  user: {
    name: '',
    email: '',
    userType: 'user'
  },
};

export default NewUser;
